import ModelEntity from "../../model-entity";
import {EntityType} from "../../../gd/const/item";
import ErrorProto from "../../../gd/validation/error";
import ErrorFieldRequired from "../../../gd/validation/error-field-required";
import ErrorFieldIncorrectValue from "../../../gd/validation/error-field-incorrect-value";
import ApiHourlyRateHistory from "../api/api";
import DateTimeUtils from "../../../gd/utils/datetime-utils";
import ModelProxy from "../../model-proxy";


export default class HourlyCostHistory extends ModelEntity {

    public userId?         : ID

    public startMoment     : Moment
    public endMoment       : Moment

    public startTimestamp  : number
    public endTimestamp    : number

    public laborRate       : number     // per hour
    public serviceRate     : number     // per hour

    constructor(data:any, useProxy:boolean = true) {

        super(data.id, EntityType.HOURLY_COST_HISTORY)

        this.userId             = _.get(data,'userId', undefined)

        this.laborRate          = _.get(data,'laborRate', 0)
        this.serviceRate        = _.get(data,'serviceRate', 0)

        this.startMoment        = DateTimeUtils.datetimeToMoment(_.get(data,'startMoment'))
        this.endMoment          = DateTimeUtils.datetimeToMoment(_.get(data,'endMoment'))

        this.startTimestamp     = this.startMoment ? this.startMoment.valueOf() : 0 // can be 0 when create new model...
        this.endTimestamp       = this.endMoment ? this.endMoment.valueOf() : 0

        return useProxy ? new Proxy(this, ModelProxy) : this
    }

    validate():ErrorProto[] | null  {

        const errors : any[] = []

        if (!this.startMoment) errors.push(new ErrorFieldRequired(gd.fields.timeCostHistory.startMoment))


        if (!this.endMoment) {
            errors.push(new ErrorFieldRequired(gd.fields.timeCostHistory.endMoment))
        } else {
            if (this.startMoment && this.startMoment.isAfter(this.endMoment)) {
                errors.push(new ErrorFieldIncorrectValue(gd.fields.timeCostHistory.endMoment))
            }
        }

        // if (!this.laborRate) errors.push(new ErrorFieldRequired(gd.fields.timeCostHistory.laborRate))


        if (!this.laborRate) {
            errors.push(new ErrorFieldRequired(gd.fields.timeCostHistory.laborRate))
        } else if (!gd.fields.timeCostHistory.laborRate.isValueValid(this.laborRate)) {
            errors.push(new ErrorFieldIncorrectValue(gd.fields.timeCostHistory.laborRate))
        }

        if (!this.serviceRate) {
            errors.push(new ErrorFieldRequired(gd.fields.timeCostHistory.serviceRate))
        } else if (!gd.fields.timeCostHistory.serviceRate.isValueValid(this.serviceRate)) {
            errors.push(new ErrorFieldIncorrectValue(gd.fields.timeCostHistory.serviceRate))
        }




        //
        // if (this.isUnitBased) {
        //     if (!this.units) errors.push(new ErrorFieldRequired(gd.fields.expense.units))
        //     if (!gd.fields.expense.units.isValueValid(this.units)) errors.push(new ErrorFieldIncorrectValue(gd.fields.expense.units))
        // }
        //
        // if (!this.expenseDate) errors.push(new ErrorFieldRequired(gd.fields.expense.expenseDate))

        // gd.fields.expense.amount.isValueValid(this.amount)

        if (_.isEmpty(errors)) return null
        else return errors
    }

    get isCompany():boolean {
        return !this.userId
    }

    get isUser():boolean {
        return !!this.userId
    }


    // Data functions
    async save() {

        if (this.id) {
            // update
            const response = await ApiHourlyRateHistory.update(this).promise()
        } else {
            // create new
            const response = await ApiHourlyRateHistory.create(this).promise()
        }

    }

    async delete() {
        const response = await ApiHourlyRateHistory.delete(this).promise()
    }


    toJSON() {
        return {
            id              : this.id,
            // startMoment       : DateTimeUtils.momentToUTCISODatetime(this.startMoment),
            // endMoment         : DateTimeUtils.momentToUTCISODatetime(this.endMoment),
            userId          : this.userId,

            startMoment       : this.startMoment.format("YYYY-MM-DD"),
            endMoment         : this.endMoment.format("YYYY-MM-DD"),

            laborRate       : _.toInteger(this.laborRate),
            serviceRate     : _.toInteger(this.serviceRate),
        }
    }

    updatedFieldsToJSON() {
        const payload : any =  {}

        this.updatedFields.forEach((fieldId:string)=>{

            switch (fieldId) {

                case 'startMoment':
                case 'endMoment':
                    payload[fieldId] = _.get(this, fieldId).format("YYYY-MM-DD")
                    break

                default:
                    payload[fieldId] = _.get(this, fieldId)
                    break
            }



        })

        return payload
    }

}